import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientDetails.scss';export default {
  "ClientDetails": "_ClientDetails_vw6um_1"
};